@if (root && item.label && item.visible !== false) {
    <div class="layout-menuitem-root-text">{{ item.label }}</div>
}

@if ((!item.routerLink || item.items) && item.visible !== false) {
    <a
        [attr.href]="item.url"
        [attr.target]="item.target"
        [attr.data-testid]="item.testId"
        tabindex="0"
        (click)="itemClick($event)"
        (keydown.enter)="itemClick($event)"
    >
        <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.label }}</span>
        @if (item.items) {
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler text-[18px]!"></i>
        }
    </a>
}

@if (item.routerLink && !item.items && item.visible !== false) {
    <a
        [routerLink]="item.routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="{
            paths: 'exact',
            queryParams: 'ignored',
            matrixParams: 'ignored',
            fragment: 'ignored',
        }"
        [attr.target]="item.target"
        [attr.data-testid]="item.testId"
        tabindex="0"
        (click)="itemClick($event)"
    >
        <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text">{{ item.label }}</span>
    </a>
}

@if (item.items && item.visible !== false) {
    <ul [@children]="root || active() ? 'expanded' : 'collapsed'">
        @for (child of item.items; track child; let i = $index) {
            <li app-admin-menuitem [item]="child" [index]="i" [parentKey]="key"></li>
        }
    </ul>
}
